import apiClient from './apiClient';

const monthlyVacationService = {
  async get(year, month) {
    const response = await apiClient.get('/employee/monthly-vacation', { params: { year, month } });
    return response.data.data;
  },
  async save(year, month, vacationTaken) {
    const response = await apiClient.put('/employee/monthly-vacation', { year, month, vacationTaken });
    return response.data.data;
  },
};

export default monthlyVacationService;
